import { logFeature } from '@office-start/telemetry-service';
// Regex that matches the following: hex:number
var driveIdItemIdRegex = /^[0-9a-fA-F]+![0-9]+$/;
var logOdspParseError = function (item, error) {
    var _a;
    logFeature({
        featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
        eventName: "Edgeworth_Parse_Error" /* KnownFeatureInstrumentationEvents.EdgeworthParseError */,
        params: (_a = {},
            _a["DocumentId" /* InstrumentationParam.DocumentId */] = item.id,
            _a["Error" /* InstrumentationParam.Error */] = error,
            _a),
    });
};
export var getOdspShareInfo = function (_a) {
    var _b, _c, _d;
    var isRedeemed = _a.isRedeemed, item = _a.item, sharepointIds = _a.sharepointIds, source = _a.source, url = _a.url, webUrl = _a.webUrl;
    if (!source) {
        logOdspParseError(item, "item source is missing or empty");
        return {
            enabled: false,
        };
    }
    if (source === 'OneDriveForConsumer') {
        if (!driveIdItemIdRegex.test((_b = item.onedrive_info) === null || _b === void 0 ? void 0 : _b.item_id)) {
            logOdspParseError(item, 'ODC item_id is not in the format of "<hexDriveId>!<numericItemId>"');
            return {
                enabled: false,
            };
        }
        if (!((_c = item.onedrive_info) === null || _c === void 0 ? void 0 : _c.drive_id) || !((_d = item.onedrive_info) === null || _d === void 0 ? void 0 : _d.item_id)) {
            logOdspParseError(item, 'ODC item is missing drive_id or item_id');
            return {
                enabled: false,
            };
        }
        return {
            enabled: true,
            type: 'Consumer',
            driveId: item.onedrive_info.drive_id,
            itemId: item.onedrive_info.item_id,
            url: url !== null && url !== void 0 ? url : webUrl,
        };
    }
    else if (source === 'OneDriveForBusiness' || source === 'SharePoint') {
        if (sharepointIds === undefined) {
            logOdspParseError(item, 'ODB item is missing sharePoint Ids');
            return {
                enabled: false,
            };
        }
        var enabled = !!sharepointIds.siteUrl && (!!url || (!!webUrl && isRedeemed));
        if (!enabled) {
            logOdspParseError(item, 'Sharing disabled for item. siteUrl or URLs are missing');
        }
        return {
            enabled: enabled,
            type: 'Commercial',
            sharePointIds: sharepointIds,
            url: url !== null && url !== void 0 ? url : webUrl,
        };
    }
    return {
        enabled: false,
    };
};
//# sourceMappingURL=odspShareUtilities.js.map